import './App.scss';

import React, { FC } from 'react';
import { EveRoutes } from '@ver-uds/e-verify';
import { Route, Redirect, Switch } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';
import MainRoute from './components/MainRoute/MainRoute';
import DashboardAccountNotFound from './components/Dashboard/DashboardAccountNotFound/DashboardAccountNotFound';

interface DashboardRoutesProps {
  isMaintenanceMode?: boolean;
}

const DashboardRoutes: FC<DashboardRoutesProps> = ({ isMaintenanceMode = false }) => {
  return (
    <div className="dashboard">
      <Switch>
        {isMaintenanceMode && (
          <Route path="/">
            <Redirect to="/maintenance" />
          </Route>
        )}

        <MainRoute exact path={EveRoutes.DASHBOARD}>
          <Dashboard />
        </MainRoute>
        <MainRoute exact path={EveRoutes.DASHBOARD_NOT_FOUND}>
          <DashboardAccountNotFound />
        </MainRoute>
        <Route path="/">
          <Redirect to={EveRoutes.DASHBOARD} />
        </Route>
      </Switch>
    </div>
  );
};

DashboardRoutes.defaultProps = {
  isMaintenanceMode: false,
};

export default DashboardRoutes;
